import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
    state: () => {
        return {
            width: 0,
            measured: false,
            modal: {
                message: '',
                confirm: false,
                confirmYes: 'Okay',
                confirmNo: 'Cancel',
                confirmAction: null,
                isActive: false,
                isWarning: false,
            }
        };
    },
    getters: {

    },
    actions: {
        closeModal() {
            this.modal.isActive = false;
            this.modal.message = '';
        }
    },
});
